import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ChevronRight16() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.26601 12.6576L10.666 7.99089L6.26602 3.32422",
      stroke: "currentColor",
      "stroke-width": "1.33333",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  });
}